import { Container } from '@shared-ui/components/ui/grid'
import { Loader } from '@shared-ui/components/ui/loader'
import { SheetContext, type SheetContextValue } from '@web/sheets/context'
import { SheetDrawerContent } from '@web/sheets/sheet-drawer-content'
import type { SheetDrawerStyles } from '@web/sheets/styles'
import { type ComponentType, Suspense } from 'react'

type SheetContainerDrawerContentProps = {
  styles: SheetDrawerStyles
  ctxValue: SheetContextValue
  Component: ComponentType
  isHandleVisible?: boolean
}

export function SheetContainerDrawerContent({
  styles,
  ctxValue,
  Component,
  isHandleVisible = true,
}: SheetContainerDrawerContentProps) {
  return (
    <SheetDrawerContent
      contentStyle={styles.content}
      handleWrapStyle={styles.handleWrap}
      handleStyle={styles.handle}
      bodyStyle={styles.body}
      isHandleVisible={isHandleVisible}
    >
      <SheetContext.Provider value={ctxValue}>
        <Suspense
          fallback={
            <Container center flex={1} style={{ minHeight: 100 }}>
              <Loader size={48} />
            </Container>
          }
        >
          <Component />
        </Suspense>
      </SheetContext.Provider>
    </SheetDrawerContent>
  )
}
